import { all } from "redux-saga/effects";

import getListCVCampaignSaga from "./getList";
import forwardEvaluationSaga from "./forwardEvaluation";
import getCvOfCampaignSaga from "./getCvOfCampaign";
import getInfoSelectedCandidateSaga from "./getInfoSelectedCandidate";
import getDetailCampaignSaga from "./getDetailCampaign";
import evaluateCVSaga from "./evaluateCV";
import evaluateCampaignSaga from "./evaluateCampaign";
import getDetailEvaluationSaga from "./getDetailEvaluation";
import getEventsSaga from "./getEvent";
import getDetailInterviewSaga from "./getDetailInterview";
import confirmParticipateSaga from "./confirmParticipate";
import updateResultPanelSaga from "./updateResultPanel";
import getListProgramSaga from "./getListProgram";

export default function* recruitmentSaga() {
  yield all([
    getListCVCampaignSaga(),
    forwardEvaluationSaga(),
    getCvOfCampaignSaga(),
    getInfoSelectedCandidateSaga(),
    getDetailCampaignSaga(),
    evaluateCVSaga(),
    evaluateCampaignSaga(),
    getDetailEvaluationSaga(),
    getEventsSaga(),
    getDetailInterviewSaga(),
    confirmParticipateSaga(),
    updateResultPanelSaga(),
    getListProgramSaga(),
  ]);
}
